import { encodeUri } from ".";
import { radiusFormatter } from "./formatters";

const getParameterByName = (name: string): string => {
  const regex = new RegExp(
    `[\\?&]${name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')}=([^&#]*)`
  );
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const getSubscribePayload = (
  params: ISubscribe,
  jrConfigGlobal: Readonly<JrConfigGlobal> = window.jrConfigGlobal): string => {
  const {
    what,
    where,
    email,
    source,
    password,
    referrer,
    firstname,
    lastname,
    captchaResponse,
    radius
  } = params;
  const url: string[] = [];

  url.push(`w=${encodeUri(what)}`);
  url.push(`l=${encodeUri(where)}`);
  url.push(
    `r=${jrConfigGlobal.feature.distanceFilterEnabled && !!where ? encodeUri(radiusFormatter(radius)) : ''
    }`
  );
  url.push('ConditionAcceptance=on');
  url.push(`Email=${encodeUri(email)}`);
  url.push(`ParentShardId=${jrConfigGlobal.jobletter.jobseeker.parentShardId}`);
  url.push(`ParentUserId=${jrConfigGlobal.jobletter.jobseeker.parentUserId}`);
  url.push('DemAcceptance=true');
  url.push(`s=${source || ''}`);
  url.push(`subscriptionSource=${source || ''}`);
  url.push(`password=${password || ''}`);
  url.push(`referrer=${referrer || ''}`);
  url.push(`firstname=${firstname || ''}`);
  url.push(`lastname=${lastname || ''}`);
  if (captchaResponse) {
    url.push(`captchaUserResponse=${captchaResponse || ''}`);
  }

  return url.join('&');
}

export const getAddMySearchesPayload = (mySearches: IModalMySearch[], email: string): string => (
  [
    ...mySearches.map((mySearch, index) => `w${index + 2}=${encodeUri(mySearch.what)}&l${index + 2}=${encodeUri(mySearch.where)}`),
    `Email=${email}`
  ])
  .join('&');

export const getUpdateProfilePayload = ({
  firstName = '',
  lastName = '',
  gdprJobMarketingAccepted,
  password = '',
  confirmPassword = '',
  oldPassword = 'old-password' }: IMyprofilePayload): string => {
  const url: string[] = [];

  if (firstName) url.push(`firstname=${encodeUri(firstName)}`);
  if (lastName) url.push(`lastname=${encodeUri(lastName)}`);
  if (gdprJobMarketingAccepted) url.push(`gdprjobmarketingaccepted=${gdprJobMarketingAccepted}`);
  url.push(`password=${password}`);
  url.push(`old-password=${oldPassword}`);
  url.push(`confirm-password=${confirmPassword}`);

  return url.join('&');
}

export const getLoginPayload = ({ email, password }: ILoginPayload): string => {
  const url: string[] = [];

  url.push(`login-email=${encodeUri(email)}`);
  url.push(`login-password=${password}`);

  return url.join('&');
}

export const getRecoverPasswordPayload = (email: string): string => {
  const url: string[] = [];
  url.push(`recover-password-email=${encodeUri(email)}`);

  return url.join('&');
}

export const getResetPasswordPayload = ({ password = '', confirmPassword = '' }: IResetPasswordPayload): string => {
  const url: string[] = [];

  url.push(`reset-password=${password}`);
  url.push(`reset-password-confirm=${confirmPassword}`);
  url.push(`token=${getParameterByName('token')}`);

  return url.join('&');
}